import React from 'react';

// ── New Furloop landing (redesign — see landing-page-redesign.md) ──
import Hero from './landing/Hero';
import Problem from './landing/Problem';
import ConnectedWorkflow from './landing/ConnectedWorkflow';
import HowItWorks from './landing/HowItWorks';
import Preflight from './landing/Preflight';
import DriverIntelligence from './landing/DriverIntelligence';
import RobotRnD from './landing/RobotRnD';
import WhoItsFor from './landing/WhoItsFor';
import Faq from './landing/Faq';
import RegisterInterest from './landing/RegisterInterest';

function Home() {
  return (
    <div className="bg-brand-bg">
      <Hero />
      <Problem />
      <ConnectedWorkflow />
      <HowItWorks />
      <Preflight />
      <DriverIntelligence />
      <RobotRnD />
      <WhoItsFor />
      <Faq />
      <RegisterInterest />
    </div>
  );
}

export default Home;
